import React from "react";
import { useNavigate } from "react-router-dom";
import AppButton from "@/components/buttons/AppButton";
import Logo from "@/components/layouts/Logo";
import { BUTTONS, TEXT } from "@/utils/constants/appConstants/commonConstants";

interface ForgotPasswordSuccessProps {
    setShow?: (show: boolean) => void;
    title?: string;
}

const ForgotPasswordSuccess: React.FC<ForgotPasswordSuccessProps> = (props) => {
    const navigate = useNavigate();
    const isChangePassword = props?.title === "change-password";

    return (
        <div className="gs-auth-success">
            <div className="gs-auth-success-logo">
                <Logo id="forgot-password-success" />
            </div>
            <h4 className="gs-auth-success-title" id="forgot-password-success-title">
                {isChangePassword ? TEXT.SET_SUCCESS_TITLE : TEXT.FORGOT_SUCCESS_TITLE}
            </h4>
            <p className="gs-auth-success-message" id="forgot-password-success-message">
                {isChangePassword ? TEXT.SET_SUCCESS_MESSAGE : TEXT.FORGOT_SUCCESS_MESSAGE}
            </p>
            <AppButton
                id="forgot-password-success-back-to-login-btn"
                btnText={isChangePassword ? BUTTONS.BACK_TO_DASHBOARD : BUTTONS.BACK_TO_LOGIN}
                className="btn-lg btn-block btn-primary gs-auth-success-btn"
                onClick={() => navigate(isChangePassword ? "/dashboard" : "/")}
            />
        </div>
    );
};

export default ForgotPasswordSuccess;
